var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIndividualPlanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#DCDAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 16L9.33325 17.6666L15.7614 20.8807C15.8489 20.9244 15.8926 20.9463 15.9385 20.9549C15.9791 20.9625 16.0208 20.9625 16.0614 20.9549C16.1073 20.9463 16.151 20.9244 16.2384 20.8807L22.6666 17.6666L19.3333 16M9.33325 14.3333L15.7614 11.1192C15.8489 11.0755 15.8926 11.0536 15.9385 11.045C15.9791 11.0374 16.0208 11.0374 16.0614 11.045C16.1073 11.0536 16.151 11.0755 16.2384 11.1192L22.6666 14.3333L16.2384 17.5474C16.151 17.5911 16.1073 17.613 16.0614 17.6216C16.0208 17.6292 15.9791 17.6292 15.9385 17.6216C15.8926 17.613 15.8489 17.5911 15.7614 17.5474L9.33325 14.3333Z",
    stroke: "#5148D7",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualPlanIcon);
export default __webpack_public_path__ + "static/media/Individual-plan-icon.3d8dd7d5.svg";
export { ForwardRef as ReactComponent };